import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../html/element'
import { Icon } from '../../../../html/icon'
import { ScrollComponent } from '../../../../scrollComponent'
import classes from './index.module.scss'
import { List } from './List'

export const SIDE_BAR_SCROLL_ID = 'SIDE_BAR_SCROLL_ID'

export const SideBar = ({ data, actionReset, onTab, changeTab }) => {
  const renderComponent = () => {
    const Component = data?.find((item) => item?.key === onTab)?.component
    return <Component />
  }

  return (
    <div className={classes.container}>
      <Element
        style={{ backgroundColor: '#F3F3F3', color: '#191D25' }}
        className={classes.navBar}
      >
        <List data={data} onTab={onTab} changeTab={changeTab} />
      </Element>
      <div className={classes.content}>
        <ScrollComponent id={SIDE_BAR_SCROLL_ID}>
          <div className={classes.paddingContent}>
            {renderComponent()}
            <Element
              className={classes.btnReset}
              style={{
                borderColor: '#0553A5',
                color: '#0553A5',
              }}
              onClick={actionReset}
            >
              <Icon className="icon-reset2" />
              <Translate value="library.filterSetting.RESET" />
            </Element>
          </div>
        </ScrollComponent>
      </div>
    </div>
  )
}
